import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChatComponent } from './chat/chat.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { PipesModule } from '../../pipes/pipes.module';
import { SharedModule } from 'src/app/shared/shared.module';
import {GoogleAnalyticsModule} from '../tracking/google-analytics.module';

@NgModule({
    declarations: [
        ChatComponent
    ],
    imports: [
        CommonModule,
        AngularSvgIconModule,
        FormsModule,
        PipesModule,
        ReactiveFormsModule,
        SharedModule,
        GoogleAnalyticsModule,
    ],
    exports: [
        ChatComponent
    ],
})
export class ChatModule {
}
